/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import * as Config from "./config";

async function reqBanner(token) {    
	const API_URI_BANNER = Config.bannerRoute;
    const response = await axios.get(API_URI_BANNER, {
        headers: { Authorization: "Bearer " + token },
    });    
    return response.data;    
}

export default {reqBanner};